<template>
  <div class="salesOrder">
    <div slot="toolbar" class="toolbar-btn">
      <div
          class="chaxun"
          style="margin-bottom: 5px; display: flex; flex-direction: row; align-items: center; flex-wrap: wrap">
        <div style="width: 100%; border-bottom: 1px solid #cccccc; margin-bottom: 5px">
          <el-button
              :loading="exportExcelLoading"
              style="background: none; border: none"
              icon="el-icon-files"
              @click="exportExcel(1)">
            导出
          </el-button>
        </div>
        <div style="display: flex; flex-direction: row; align-items: center; flex-wrap: wrap">
          <el-button type="primary" @click="visible=true;customerName='';fileName=''">大客户销单导入</el-button>
          <el-dialog
              :visible.sync="visible"
              title="文件导入">
            <el-form
                label-width="240px">
              <el-form-item label="导入类型:">
                <el-select v-model="customerName" placeholder="请选择导入类型" style="width:640px;">
                  <el-option label="印度蒂森STO控制柜" value="印度蒂森STO控制柜"/>
                  <el-option label="印度蒂森散件" value="印度蒂森散件"/>
                  <el-option label="韩国蒂森订单" value="韩国蒂森订单"/>
                  <el-option label="进口蒂森控制柜" value="进口蒂森控制柜"/>
                </el-select>
              </el-form-item>
              <el-form-item v-if="customerName === '印度蒂森散件'" label="包装方式">
                <el-select v-model="packType" placeholder="请选择包装方式" style="width:640px;">
                  <el-option value="木箱" label="木箱"/>
                  <el-option value="纸箱" label="纸箱"/>
                </el-select>
              </el-form-item>
              <el-form-item label="文件名称:">
                <el-input v-model="fileName" style="width:240px;float: left;"/>
                <el-upload
                    multiple
                    action=""
                    :on-change="onUploadChange"
                    :show-file-list="false"
                    :disabled="uploadLoading"
                    style="float: left;;margin-left: 5px;padding: 0;">
                  <el-button type="primary">选择导入文件</el-button>
                </el-upload>
              </el-form-item>
            </el-form>
            <div slot="footer">
              <el-button type="primary" @click="visible=false">取消</el-button>
              <el-button
                  v-loading.fullscreen.lock="uploadLoading"
                  element-loading-text="导入中请稍后..."
                  loading-text-
                  type="primary"
                  @click="submitUpload">
                导入
              </el-button>
            </div>
          </el-dialog>
          <div style="display: flex; flex-direction: row; align-items: center; margin-top: 5px">
            <el-upload action="" :http-request="priceImport" :show-file-list="false" :file-list="fileList">
              <el-button :loading="priceImportLoading" type="primary" plain style="margin-left: 5px">导入蒂森价格</el-button>
            </el-upload>
          </div>
          <div style="display: flex; flex-direction: row; align-items: center; margin-top: 5px">
            <el-upload action="" :http-request="priceImportGuangri" :show-file-list="false" :file-list="fileList">
              <el-button :loading="priceImportLoading" type="primary" plain style="margin-left: 5px">导入广日价格</el-button>
            </el-upload>
          </div>
          <div style="display: flex; flex-direction: row; align-items: center; margin-top: 5px">
            <el-upload action="" :http-request="priceImportLingWang" :show-file-list="false" :file-list="fileList">
              <el-button :loading="priceImportLoading" type="primary" plain style="margin-left: 5px">导入菱王价格</el-button>
            </el-upload>
          </div>
          <div style="display: flex; flex-direction: row; align-items: center; margin-top: 5px">
            <el-upload action="" :http-request="priceImportAoDiSi" :show-file-list="false" :file-list="fileList">
              <el-button :loading="priceImportLoading" type="primary" plain style="margin-left: 5px">导入奥的斯价格</el-button>
            </el-upload>
          </div>
          <div style="display: flex; flex-direction: row; align-items: center; margin-top: 5px">
            <el-button type="primary" plain style="margin-left: 5px" @click="DsDataExportClick">韩国蒂森井道数据导出</el-button>
          </div>
          <div style="display: flex; flex-direction: row; align-items: center; margin-top: 5px">
            <el-button type="primary" plain style="margin-left: 5px" @click="SelectFileClick">蒂森项目信息表导出</el-button>
          </div>
          <el-dialog
              :visible.sync="DsExportVisible"
              title="韩国蒂森井道数据导出"
              width="400px">
            <el-form
                ref="formUplosd"
                enctype="multipart/form-data"
                label-position="right"
                label-width="120px"
                size="mini">
              <el-upload
                  action=""
                  multiple
                  :on-change="fileChange"
                  :auto-upload="false"
                  :show-file-list="true"
                  :file-list="fileList">
                <el-button :loading="exportLoading" type="primary" plain style="margin-left: 5px">点击上传文件</el-button>
              </el-upload>
            </el-form>
            <div slot="footer">
              <el-button type="primary" plain :loading="exportLoading" @click="DsDataExport">确定</el-button>
            </div>
          </el-dialog>
          <div style="display: flex; flex-direction: row; align-items: center; margin-top: 5px">
            <el-button
                type="primary"
                :loading="exportExcelLoading"
                plain
                style="margin-left: 5px"
                @click="exportExcel(2)">
              生产订单明细导出
            </el-button>
          </div>
        </div>
      </div>
    </div>
    <template>
      <div style="width: 100%; background: #f4f7fa; margin-top: 10px; margin-bottom: 10px">
        <div
            style="display: flex; flex-direction: row; justify-content: space-between; align-items: center; margin: 5px 0">
          <div>
            <el-button plain :style="buttonStyle" @click="newTime"> 2020年1月1日以后</el-button>
            <el-button plain :style="buttonStyle1" @click="oldTime"> 更早</el-button>
            <el-button
                plain
                size="mini"
                :loading="orderConfigLoading"
                style="height: 26px; padding: 0 10px; margin-left: 5px"
                @click="orderConfigTest">
              PLM订单选配测试
            </el-button>
          </div>
          <div>
            <el-button
                type="primary"
                class="adSearchShow"
                style="background: none; border: none; color: #2d8cf0"
                :icon="adSearchShow ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"
                @click="adSearchShow = !adSearchShow">
              {{adSearchShow ? "收起" : "展开"}}
            </el-button>
          </div>
        </div>
        <div v-if="adSearchShow" class="sousuo">
          <div class="sousuo-nr">
            <vm-search label="订单编号">
              <el-input v-model.trim="filter.salesOrderNO" style="width: 150px" clearable/>
            </vm-search>
            <vm-search label="SAP订单号">
              <el-input v-model.trim="filter.sAPSalesOrderNO" style="width: 150px" clearable/>
            </vm-search>
            <vm-search label="客户名称">
              <el-input v-model.trim="filter.customerName" style="width: 150px" clearable/>
            </vm-search>
            <vm-search label="客户合同号">
              <el-input v-model.trim="filter.clientContractNO" style="width: 150px" clearable/>
            </vm-search>
            <vm-search label="项目名称">
              <el-input v-model.trim="filter.projectName" style="width: 150px" clearable/>
            </vm-search>
            <vm-search label="状态">
              <el-select v-model.trim="filter.status" style="width: 150px" clearable placeholder="请选择">
                <el-option
                    v-for="item in constant.toSelect(constant.salesStatus)"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"/>
              </el-select>
            </vm-search>
            <vm-search label="产品类型">
              <el-select v-model.trim="filter.productType" style="width: 150px" clearable placeholder="请选择">
                <el-option :value="-1" label="全部"/>
                <el-option :value="0" label="非标准产品"/>
                <el-option :value="10" label="标准产品"/>
              </el-select>
            </vm-search>
            <vm-search label="创建者">
              <el-input v-model.trim="filter.creatorName" style="width: 150px" clearable/>
            </vm-search>
            <div class="date-display">
              <vm-search label="提交时间">
                <div class="block">
                  <el-date-picker
                      v-model="filter.beginSubmitTime"
                      :picker-options="pickerOptions"
                      placement="bottom-start"
                      value-format="yyyy-MM-dd"
                      type="date"
                      style="width: 150px"
                      placeholder="选择开始日期"/>
                </div>
              </vm-search>
              <vm-search label="至" class="zhi">
                <div class="block">
                  <el-date-picker
                      v-model="filter.endSubmitTime"
                      :picker-options="pickerOptions"
                      placement="bottom-start"
                      value-format="yyyy-MM-dd"
                      type="date"
                      style="width: 150px"
                      placeholder="选择结束日期"/>
                </div>
              </vm-search>
            </div>
            <div class="vm-search" style="display: flex; flex-direction: row; align-items: center; margin-top: 5px">
              <div style="font-size: 13px; display: flex; flex-direction: row; align-items: center;">
                <span style="display: block; padding: 0 10px; margin-top: -3px;">包含控制柜</span>
                <el-radio-group v-model="filter.includeControlBox" class="radiobg" @change="handleChange">
                  <el-radio :label="-1">全部</el-radio>
                  <el-radio :label="0">不包含</el-radio>
                  <el-radio :label="1">包含</el-radio>
                </el-radio-group>
              </div>
              <div style="font-size: 13px; display: flex; flex-direction: row; align-items: center;">
                <span style="display: block; padding: 0 10px; margin-top: -3px">关键物料</span>
                <el-radio-group v-model="filter.keyMaterial" class="radiobg" @change="handleChange">
                  <el-radio label="0">全部</el-radio>
                  <el-radio label="1">未设置</el-radio>
                  <el-radio label="2">已设置</el-radio>
                </el-radio-group>
              </div>
              <div style="font-size: 13px; display: flex; flex-direction: row; align-items: center;">
                <span style="display: block; padding: 0 10px; margin-top: -3px">合同</span>
                <el-radio-group v-model="filter.contractAttachment" class="radiobg" @change="handleChange">
                  <el-radio :label="0">全部</el-radio>
                  <el-radio :label="10">不包含</el-radio>
                  <el-radio :label="20">包含</el-radio>
                </el-radio-group>
              </div>
            </div>
          </div>
          <div class="ad-search-btn">
            <el-button
                :loading="loading"
                type="primary"
                size="mini"
                style="height: 26px; padding: 0 10px"
                @click="handleSearchClick">
              查询
            </el-button>
            <el-button
                plain
                type="primary"
                size="mini"
                style="height: 26px; padding: 0 10px"
                @click="handleClearClick">
              重置
            </el-button>
          </div>
        </div>
      </div>
    </template>
    <el-table
        v-loading="loading"
        :data="tableData"
        height="60vh"
        style="width: 100%"
        @select="selectOne"
        @select-all="selectAll">
      <el-table-column type="selection" align="center" width="55"/>
      <el-table-column
          prop="accessory"
          label=""
          :render-header="renderHeader"
          width="50"
          align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.accessoryInfo > 0">
            <i class="el-icon-paperclip"/>
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="salesOrderNO" align="center" width="100" label="编号">
        <template slot-scope="scope">
          <div style="color: #2d8cf0; cursor: pointer" @click="goto(scope.row)">{{scope.row.salesOrderNO}}</div>
        </template>
      </el-table-column>
      <el-table-column prop="projectName" align="center" label="项目名称" min-width="240"/>
      <el-table-column prop="customerName" align="center" label="客户" min-width="200"/>
      <el-table-column
          prop="creatorName"
          align="center"
          width="120"
          label="创建者"
          show-overflow-tooltip/>
      <el-table-column prop="finalDeliveryDate" align="center" width="135" label="计划调整交期"/>
      <el-table-column prop="sapsalesOrderNO" align="center" width="100" label="SAP订单号"/>
      <el-table-column prop="clientContractNO" align="center" label="客户合同号" width="120"/>
      <el-table-column prop="deliveryDate" align="center" width="90" label="计划交期"/>
      <el-table-column prop="orderType" align="center" width="70" label="订单类型"/>
      <el-table-column prop="totalMoney" align="center" width="90" label="总金额"/>
      <el-table-column prop="submitTime" align="center" width="135" label="提交时间"/>
      <el-table-column prop="status" align="center" width="100" label="状态">
        <template slot-scope="scope">
          {{constant.salesStatus[scope.row.status]}}
        </template>
      </el-table-column>
      <el-table-column prop="deliveryStatusName" align="center" width="70" label="发货状态"/>
      <el-table-column prop="trackingNote" align="center" width="70" label="跟踪信息">
        <template slot-scope="scope">
          <el-button plain @click="$refs.traceSalesOrder.open(scope.row.pkid)">添加</el-button>
        </template>
      </el-table-column>
      <el-table-column
          label="操作"
          align="center"
          class-name="vm-table_operate"
          width="160">
        <template slot-scope="scope">
          <el-button v-if="editAuth" @click="salesOrderEdit(scope.row)">编辑</el-button>
          <el-button v-if="editAuth" @click="salesOrderEdit(scope.row,true)">复制</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div style="margin-top: 16px; overflow: hidden; color: #000">
      <el-pagination
          class="page"
          :page-sizes="[10, 50, 100, 200, 300, 500]"
          :page-size.sync="pageSize"
          :current-page="currentPage"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          @size-change="handleSizeChange"
          @current-change="changePage"/>
    </div>
    <sales-order-trace ref="traceSalesOrder" @save-success="getList(-1)"/>
    <select-file-dialog ref="selectFileDialog" @save_success="getList(-1)"/>
  </div>
</template>

<script>
  import SalesOrderTrace from "@/views/salesManage/salesOrder/SalesOrderTrace";
  import VmSearch from "@/components/VmSearch";
  import loginUtil from "@/util/loginUtil";
  import constant from "@/util/constant";
  import SelectFileDialog from "@/views/salesManage/salesOrder/SelectFileDialog";

  export default {
    name: "SalesOrder",
    components: {VmSearch, SalesOrderTrace, SelectFileDialog},
    data() {
      return {
        constant,
        submitDate: [],
        editAuth: this.$auth(179),
        exportExcelLoading: false,
        KrTKEImportLoading: false,
        IndTKEImportLoading: false,
        priceImportLoading: false,
        orderConfigLoading: false,
        yiXinApplicationDialog: false,
        DsExportVisible: false,
        SelectFileDialog: false,
        exportLoading: false,
        uploadLoading: false,
        isBtn: true,
        isBtn1: false,
        visible: false,
        customerName: "",
        packType:"",
        fileName: "",
        adSearchShow: true,
        loading: false,
        fileList: [],
        pickerOptions: {
          disabledDate: (time) => {
            return this.dealDisabledDate(time);
          },
        },
        options1: [
          {
            value1: "选项1",
            label: "新中山唛头",
          },
          {
            value1: "选项2",
            label: "新上海唛头",
          },
          {
            value1: "选项3",
            label: "蒂森国外India唛头",
          },
        ],
        value1: "",
        options2: [
          {
            value2: "选项1",
            label: "标准合格证模板",
          },
          {
            value2: "选项2",
            label: "曼隆合格证模板",
          },
        ],
        value2: "",
        options3: [
          {
            value3: "选项1",
            label: "苏州施耐德铭牌",
          },
          {
            value3: "选项2",
            label: "标准中文铭牌",
          },
          {
            value3: "选项3",
            label: "标准英文铭牌",
          },
          {
            value3: "选项4",
            label: "新时达标准铭牌",
          },
          {
            value3: "选项5",
            label: "新时达UCMP铭牌",
          },
          {
            value3: "选项6",
            label: "凯斯博铭牌",
          },
          {
            value3: "选项7",
            label: "凯斯博UCMP铭牌",
          },
        ],
        value3: "",
        options4: [
          {
            value4: "选项1",
            label: "蒂森二维码",
          },
          {
            value4: "选项2",
            label: "富士达标签",
          },
          {
            value4: "选项3",
            label: "装箱清单",
          },
          {
            value4: "选项4",
            label: "项目信息表",
          },
          {
            value4: "选项5",
            label: "流水单",
          },
        ],
        value4: "",
        idList: "",
        filter: {
          filter: "",
          timeSegment: 2020,
          contractAttachment: 0,
          salesOrderNO: "",
          sAPSalesOrderNO: "",
          customerName: "",
          clientContractNO: "",
          projectName: "",
          creatorName: "",
          status: "",
          beginSubmitTime: "",
          endSubmitTime: "",
          priority: "",
          includeControlBox: -1,
          keyMaterial: "",
          productType: -1,
        },
        currentPage: 1,
        pageSize: 10,
        total: 0,
        params: {
          unpaidTaxtMoney: "",
          taxIncludedMoney: "",
          strDate: "",
          editDate: "",
        },
        tableData: [],
        ids: [],
        selection: [],
        ruleValidate: {},
      };
    },
    computed: {
      buttonStyle: function() {
        return {
          color: this.isBtn ? "#2D8CF0" : "#000",
          background: "none",
          border: "none",
        };
      },
      buttonStyle1: function() {
        return {
          color: this.isBtn1 ? "#2D8CF0" : "#000",
          background: "none",
          border: "none",
        };
      },
    },
    mounted() {
      this.initTime();
    },
    methods: {
      getList(pageIndex) {
        if (
          this.filter.beginSubmitTime !== null &&
          this.filter.endSubmitTime !== null &&
          this.filter.endSubmitTime !== "" &&
          this.filter.beginSubmitTime !== ""
        ) {
          if (this.dateCompare(this.filter.endSubmitTime, this.filter.beginSubmitTime)) {
            return this.$message.error("提交开始日期不能大于提交结束日期");
          }
        }
        this.currentPage = pageIndex;
        this.loading = true;
        let params = Object.assign({pageSize: this.pageSize, pageNum: pageIndex}, this.filter);
        this.$http
          .post("basic", "sd/so/pageList", params)
          .then((res) => {
            this.loading = false;
            this.tableData = res.records;
            this.total = res.total;
          })
          .catch(() => {
            this.loading = false;
            this.$message.error("获取失败");
          });
      },

      renderHeader(h, {column}) {
        return h("span", [
          h("span", column.label),
          h("i", {
            class: "el-icon-paperclip",
            style: "color:#444444; font-size: 16px;",
          }),
        ]);
      },
      handleSearchClick() {
        this.getList(1);
      },
      handleClearClick() {
        this.filter.filter = "";
        this.filter.salesOrderNO = "";
        this.filter.sAPSalesOrderNO = "";
        this.filter.customerName = "";
        this.filter.clientContractNO = "";
        this.filter.projectName = "";
        this.filter.creatorName = "";
        this.filter.status = "";
        this.filter.beginSubmitTime = "";
        this.filter.endSubmitTime = "";
        this.filter.priority = "";
        this.filter.includeControlBox = "";
        this.filter.keyMaterial = "";
        this.filter.timeSegment = 2020;
        this.isBtn = true;
        this.isBtn1 = false;
        this.$nextTick(() => {
          this.getList(1);
        });
      },
      onProgress() {
        this.BatchTimeLoading = true;
        this.disabled = true;
      },

      handleRemove(file, fileList) {
        console.log(file, fileList);
      },

      fileChange(file, fileList) {
        this.fileList = fileList;
      },

      dialogClose() {
        this.$refs.form.resetFields();
        this.submitLoading = false;
      },

      changePage(pageIndex) {
        this.getList(pageIndex);
      },
      handleSizeChange(val) {
        this.pageSize = val;
        this.getList(1);
      },

      //韩国蒂森订单导入
      KrTKEImport(params) {
        this.KrTKEImportLoading = true;
        let formData = new FormData(); //  用FormData存放上传文件
        formData.append("file", params.file);
        formData.append("Authorization", loginUtil.getToken());
        this.$http
          .post("basic", "sd/so/praseKrTKESalesOrder", formData)
          .then((res) => {
            if (res.success) {
              this.$message({
                showClose: true,
                message: res.message,
                type: "success",
              });
              this.getList(1);
            } else {
              this.$message.error(res.message);
            }
            this.KrTKEImportLoading = false;
          })
          .catch(() => {
            this.KrTKEImportLoading = false;
          });
      },

      //印度蒂森订单导入
      IndTKEImport(params) {
        this.IndTKEImportLoading = true;
        let formData = new FormData(); //  用FormData存放上传文件
        formData.append("file", params.file);
        formData.append("Authorization", loginUtil.getToken());
        this.$http
          .post("basic", "sd/so/IndTKESaleOrderImport", formData)
          .then((res) => {
            if (res.success) {
              this.$message({
                showClose: true,
                message: res.message,
                type: "success",
              });
              this.getList(1);
            } else {
              this.$message.error(res.message);
            }
            this.IndTKEImportLoading = false;
          })
          .catch(() => {
            this.IndTKEImportLoading = false;
          });
      },

      //韩国蒂森价格导入
      priceImport(params) {
        this.$confirm("批量修改数据会影响日常业务，请在下班后执行", "提示", {
          type: "warning",
          closeOnClickModal: false,
          closeOnPressEscape: false,
        }).then(() => {
          this.priceImportLoading = true;
          let formData = new FormData(); //  用FormData存放上传文件
          formData.append("file", params.file);
          formData.append("Authorization", loginUtil.getToken());
          this.$http
            .post("basic", "sd/so/tk/sapSalesOrderPrice", formData)
            .then((res) => {
              if (res.success) {
                this.$message({
                  showClose: true,
                  duration: 0,
                  message: res.data,
                  type: "success",
                });
                this.getList(1);
              } else {
                this.$message({
                  showClose: true,
                  duration: 0,
                  message: res.message,
                  type: "error",
                });
              }
              this.priceImportLoading = false;
            })
            .catch(() => {
              this.priceImportLoading = false;
            });
        });
      },
      uploadFile(file) {
        console.log("upload", file);
      },

      priceImportGuangri(params) {
        this.$confirm("批量修改数据会影响日常业务，请在下班后执行", "提示", {
          type: "warning",
          closeOnClickModal: false,
          closeOnPressEscape: false,
        }).then(() => {
          this.priceImportLoading = true;
          let formData = new FormData(); //  用FormData存放上传文件
          formData.append("file", params.file);
          formData.append("Authorization", loginUtil.getToken());
          this.$http
            .post("basic", "sd/so/guangri/sapSalesOrderPrice", formData)
            .then((res) => {
              if (res.success) {
                this.$message({
                  showClose: true,
                  duration: 0,
                  message: res.data,
                  type: "success",
                });
                this.getList(1);
              } else {
                this.$message({
                  showClose: true,
                  duration: 0,
                  message: res.message,
                  type: "error",
                });
              }
              this.priceImportLoading = false;
            })
            .catch(() => {
              this.priceImportLoading = false;
            });
        });
      },

      priceImportLingWang(params) {
        this.$confirm("批量修改数据会影响日常业务，请在下班后执行", "提示", {
          type: "warning",
          closeOnClickModal: false,
          closeOnPressEscape: false,
        }).then(() => {
          this.priceImportLoading = true;
          let formData = new FormData(); //  用FormData存放上传文件
          formData.append("file", params.file);
          formData.append("Authorization", loginUtil.getToken());
          this.$http
            .post("basic", "sd/so/lingwang/sapSalesOrderPrice", formData)
            .then((res) => {
              if (res.success) {
                this.$message({
                  showClose: true,
                  duration: 0,
                  message: res.data,
                  type: "success",
                });
                this.getList(1);
              } else {
                this.$message({
                  showClose: true,
                  duration: 0,
                  message: res.message,
                  type: "error",
                });
              }
              this.priceImportLoading = false;
            })
            .catch(() => {
              this.priceImportLoading = false;
            });
        });
      },

      priceImportAoDiSi(params) {
        this.$confirm("批量修改数据会影响日常业务，请在下班后执行", "提示", {
          type: "warning",
          closeOnClickModal: false,
          closeOnPressEscape: false,
        }).then(() => {
          this.priceImportLoading = true;
          let formData = new FormData(); //  用FormData存放上传文件
          formData.append("file", params.file);
          formData.append("Authorization", loginUtil.getToken());
          this.$http
            .post("basic", "sd/so/aodisi/sapSalesOrderPrice", formData)
            .then((res) => {
              if (res.success) {
                this.$message({
                  showClose: true,
                  duration: 0,
                  message: res.data,
                  type: "success",
                });
                this.getList(1);
              } else {
                this.$message({
                  showClose: true,
                  duration: 0,
                  message: res.message,
                  type: "error",
                });
              }
              this.priceImportLoading = false;
            })
            .catch(() => {
              this.priceImportLoading = false;
            });
        });
      },

      //蒂森井道数据导出
      DsDataExport() {
        this.exportLoading = true;
        let formData = new FormData(); //  用FormData存放上传文件
        this.fileList.forEach(item => {
          formData.append("files", item.raw);
        });
        formData.append("Authorization", loginUtil.getToken());
        this.$http
          .postForFile("basic", "sd/so/krTKEShaftData", formData)
          .then((res) => {
            let blob = new Blob([res.data]);
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
              navigator.msSaveBlob(blob, "蒂森井道数据.zip");
            } else {
              let a = document.createElement("a");
              a.href = window.URL.createObjectURL(blob);
              a.download = "蒂森井道数据.zip";
              a.click();
              window.URL.revokeObjectURL(a.href);
            }
            this.exportLoading = false;
          })
          .catch(() => {
            this.exportLoading = false;
          });
      },
      //PLM订单选配测试
      orderConfigTest() {
        if (!this.selection || this.selection.length !== 1) {
          this.$message.warning("请选择一条订单数据！");
          return;
        }
        this.orderConfigLoading = true;
        this.$http
          .post("basic", "api/plm/order-config", {pkid: this.selection[0].pkid})
          .then((res) => {
            if (res.success) {
              this.$message({
                showClose: true,
                message: res.message || "操作成功",
                type: "success",
              });
            } else {
              this.$message.error(res.message);
            }
            this.orderConfigLoading = false;
          })
          .catch(() => {
            this.orderConfigLoading = false;
          });
      },
      handleChange() {
        this.getList(1);
      },
      selectOne(selection) {
        this.ids = [];
        this.selection = [];
        this.selection = selection;
        for (let item of selection) {
          this.ids.push(item.pkid);
        }
        this.idList = selection;
      },
      selectAll(selection) {
        this.idList = selection;
        this.selection = selection;
      },
      deleteRow(row) {
        this.$confirm("确定删除吗?", "提示", {type: "warning"}).then(() => {
          this.$http.delete("basic", "/products", row.pkid).then(() => {
            this.getList(-1);
            this.$message.success("删除成功");
          });
        });
      },
      //导出
      exportExcel(dataType) {
        let url = "";
        if (dataType === 1) {
          url = "sd/so/exportTechParamBill";
        } else if (dataType === 2) {
          url = "sd/so/exportProductionDetail";
        }
        this.exportExcelLoading = true;
        this.$http
          .exportFile("basic", url, this.filter)
          .then((res) => {
            let blob = new Blob([res.data]);
            let fileName = decodeURI(res.headers.filename);
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
              navigator.msSaveBlob(blob, fileName);
            } else {
              let a = document.createElement("a");
              a.href = URL.createObjectURL(blob);
              a.download = fileName;
              a.style.display = "none";
              document.body.appendChild(a);
              a.click();
              URL.revokeObjectURL(a.href);
              document.body.removeChild(a);
            }
            this.exportExcelLoading = false;
          })
          .catch(() => {
            this.exportExcelLoading = false;
          });
      },
      DsDataExportClick() {
        this.fileList = [];
        this.DsExportVisible = true;
      },

      SelectFileClick() {
        this.$refs.selectFileDialog.open();
      },
      salesOrderEdit(row, isCopy) {
        this.$router.push({
          path: "/salesManage/salesOrder/SalesOrderNew",
          query: {
            salesOrderId: row.pkid,
            isCopy: isCopy ? isCopy : false,
            $tabName: isCopy ? "创建销售订单" : "编辑" + row.salesOrderNO,
          },
        });
      },
      goto(row) {
        this.$router.push({
          path: "/salesOrder",
          query: {
            billType: 1,
            billId: row.pkid,
            $tabName: row.salesOrderNO,
          },
        });
      },
      initTime() {
        this.filter.endSubmitTime = this.getFormatDate(new Date());
        this.filter.beginSubmitTime = this.getFormatDate(new Date(new Date() - 3600 * 1000 * 24 * 29));
        // this.submitDate = [];
        // this.submitDate.push(this.filter.beginSubmitTime);
        // this.submitDate.push(this.filter.endSubmitTime);
        this.getList(1);
      },
      // 获取当前时间
      getFormatDate(date) {
        var month = date.getMonth() + 1;
        var strDate = date.getDate();
        if (month >= 1 && month <= 9) {
          month = "0" + month;
        }
        if (strDate >= 0 && strDate <= 9) {
          strDate = "0" + strDate;
        }
        return date.getFullYear() + "-" + month + "-" + strDate;
      },
      dealDisabledDate(time) {
        if (this.isBtn) {
          return time.getTime() < new Date("2019-12-31").getTime();
        } else {
          return time.getTime() > new Date("2019-12-31").getTime();
        }
      },
      newTime() {
        this.isBtn1 = false;
        this.isBtn = !this.isBtn;
        this.filter.timeSegment = 2020;
        this.filter.endSubmitTime = this.getFormatDate(new Date());
        this.filter.beginSubmitTime = this.getFormatDate(new Date(new Date() - 3600 * 1000 * 24 * 29));
        // this.submitDate = [];
        // this.submitDate.push(this.filter.beginSubmitTime);
        // this.submitDate.push(this.filter.endSubmitTime);
        // this.getList(1);
      },
      oldTime() {
        this.isBtn = false;
        this.isBtn1 = !this.isBtn1;
        this.filter.timeSegment = 2019;
        this.filter.beginSubmitTime = "2019-01-01";
        this.filter.endSubmitTime = "2019-12-31";
        // this.submitDate = [];
        // this.submitDate.push(this.filter.beginSubmitTime);
        // this.submitDate.push(this.filter.endSubmitTime);
        // this.getList(1);
      },
      dateCompare(date1, date2) {
        let time1 = date1.replace(/-/g, "");
        let time2 = date2.replace(/-/g, "");
        if (time1 <= time2) {
          return true;
        } else {
          return false;
        }
      },

      onUploadChange(file) {
        this.fileList[0] = file;
        this.fileName = file.name;
      },

      submitUpload() {
        if (this.customerName === "") {
          this.$message.error("请先选择客户！");
        }
        this.uploadLoading = true;
        let formData = new FormData(); //  用FormData存放上传文件
        formData.append("file", this.fileList[0].raw);
        formData.append("name", this.fileList[0].name);
        if (this.customerName === "韩国蒂森订单") {
          this.url = "sd/so/praseKrTKESalesOrder";
        } else if (this.customerName === "印度蒂森STO控制柜") {
          this.url = "sd/so/IndTKESaleOrderImport";
        } else if (this.customerName === "印度蒂森散件") {
          this.url = "sd/so/IndTKEPartsSaleOrderImport/"+this.packType;
        } else if (this.customerName === "进口蒂森控制柜") {
          this.url="sd/so/importTKESalesOrder";
        }

        this.$http
          .post("basic", this.url, formData)
          .then((res) => {
            if (res.success) {
              this.$message({
                showClose: true,
                message: res.message,
                type: "success",
              });
              this.getList(1);
            } else {
              this.$message.error(res.message);
            }
            this.uploadLoading = false;
          })
          .catch(() => {
            this.uploadLoading = false;
          });

      },

      selectCustomerName(row) {
        this.customerName = row.customerName;
      },
    },
  };
</script>

<style lang="scss" scoped>
.salesOrder {
  .vm-page-table .ad-search .ad-search_content .ad-search-btn {
    height: 28px;
  }

  .el-select {
    width: 150px !important;
  }

  .el-radio__label {
    font-size: 12px !important;
  }

  .el-radio {
    margin-right: 5px !important;
  }

  .el-radio__label {
    padding-right: 5px !important;
    padding-left: 5px !important;
  }

  .vm-page-table .ad-search .ad-search_content {
    padding: 0 !important;
    width: 100%;
  }

  .vm-page-table .ad-search .ad-search_content .ad-search-btn {
    bottom: 2px;
  }

  .el-pagination {
    text-align: right;
  }

  .sousuo {
    width: 100%;
    background: #f4f7fa;
    /*margin-top: 10px;*/
    margin-bottom: 10px;
    border-top: 1px dashed #cccccc;

    .sousuo-nr {
      padding: 10px 10px 8px 10px;

      .vm-search-com .vm-search-label[data-v-658ba3ef] {
        width: 80px !important;
        font-size: 12px !important;
      }

      .zhi {
        width: 180px !important;
      }
    }

    .ad-search-btn {
      text-align: left;
      margin: 10px 0 0 20px;
      padding-bottom: 5px;
    }
  }

  .date-display {
    display: inline-block;
  }

  .radiobg {
    background: #eaf4fe;
    padding: 5px;
    border: 1px solid #e6e6e6;
    font-size: 12px !important;

    .el-radio__label {
      font-size: 12px !important
    }
  }
}
</style>
